export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_11.9428bb9e.jpg";